import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { applicationstatuslist, UpdateJobResponse } from '../../../action/jobs';
import { toast } from 'react-toastify';

const CandidateDetail = ({ styles, data }) => {
    // const [showStatusModal, setShowStatusModal] = useState(false);
    const [statusList, setStatusList] = useState([])
    useEffect(() => {
        applicationstatuslist().then((res) => {
            if (res.status) {
                setStatusList(res.result);
            }
        });
    }, [])
    if (!data) return null;
    console.log('statusList',JSON.stringify(statusList))


    const {
        STUDENT_ID,
        RESUME_URL,
        studentDetail,
        jobDetail,
        educationList = [],
        internshipList = [],
        projectList = [],
        skillList = [],
        languageList = [],
        certificationList = [],
        portfolio = {}
    } = data;

    const fullName = `${studentDetail.FIRST_NAME || ''} ${studentDetail.LAST_NAME || ''}`;

    return (
        <div className='container-fluid'>

            {/* {showStatusModal && (
                <div className="modal fade show d-block" tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">

                            <div className="modal-header">
                                <h5 className="modal-title">Update Application Status</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => {
                                        const model = {
                                            APPLICATION_ID: data.APPLICATION_ID,
                                            STATUS_ID: data?.STATUS_ID,
                                            CANDIDATE_ID: data?.CANDIDATE_ID,
                                            SOURCE: 'STUDENT',
                                            CAMPUS_STUDENT_ID: STUDENT_ID,
                                            JOB_ID: jobDetail.JOB_ID
                                        }
                                        UpdateJobResponse(model).then(res => {
                                            if (res.status) {
                                                setShowStatusModal(false)

                                            }
                                        }).catch(err => {
                                            console.log(err)
                                        })
                                    }}
                                />
                            </div>

                            <div className="modal-body">
                                <p className="fw-6">{jobDetail?.JOB_TITLE}</p>

                                <select className="form-select">
                                    <option value="">Select Status</option>
                                    <option value="SHORTLISTED">Shortlisted</option>
                                    <option value="REJECTED">Rejected</option>
                                    <option value="INTERVIEW">Interview Scheduled</option>
                                    <option value="HIRED">Hired</option>
                                </select>
                            </div>

                            <div className="modal-footer">
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => setShowStatusModal(false)}
                                >
                                    Cancel
                                </button>
                                <button className="btn btn-primary">
                                    Update
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            )} */}
            <div className='row'>
                <div className='col-md-12'>
                    <div className={`${styles['card-ctm']}`}>
                        <div className='mb-3'>
                            <div className={`${styles['can-title']} mb-0`}>Candidate Profile</div>
                            <div className={`${styles['can-paragraph']} mb-0`}>Check your profile details and track your application status.</div>
                            <hr />
                        </div>
                        <div className={`${styles['inner-card']}`}>
                            <div className='d-flex align-items-center justify-content-between'>
                                <div className='d-flex'>
                                    <div className={`${styles['profile-img']}`}>
                                        <img src='/assets/images/Profile2.png' alt='profile image' className='img-fluid' />
                                    </div>
                                    <div className={`${styles['profile-name']} ms-2`}>
                                        <h3 className='mb-0'>{fullName}</h3>
                                    </div>
                                </div>
                                <div>
                                    <a href='#applied-job' className={`${styles['btn-ctm']} btn`}>Application</a>
                                </div>
                            </div>
                            <div className='row mt-2'>
                                <div className='col-md-12'>
                                    <p><img src='/assets/images/icons/user-square.png' alt='profile image' className='img-fluid me-2' />Student Campus ID: JZSHC{STUDENT_ID}</p>
                                    <p><img src='/assets/images/icons/marker-pin.png' alt='profile image' className='img-fluid me-2' /> {studentDetail.ADDRESS}, {studentDetail.CITY}, {studentDetail.STATE} - {studentDetail.ZIP_CODE}</p>
                                    <p>{studentDetail.PROFILE_SUMMARY}</p>
                                    <hr />
                                    <div className='d-flex align-items-center'>
                                        <img src='/assets/images/icons/info-square.png' alt='Information' className='img-fluid me-2' />
                                        <p className='mb-0'>Additional Information</p>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <div>Nationality:<strong><span className='ps-2'>{studentDetail?.NATIONALITY || '--'}</span></strong></div>
                                        </div>
                                        <div className='col-md-6 text-start'>
                                            <div>Physically Disabled:<strong><span className='ps-2'>{studentDetail?.PHYSICALLY_DISABLED === 'Y' ? 'Yes ' : 'No'}</span></strong></div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='d-flex align-items-center'>
                                        <img src='/assets/images/icons/suitecase.png' alt='Job' className='img-fluid me-2' />
                                        <p className='mb-0'>Job Preferences</p>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <div>Preferred Job Role:<strong><span className='ps-2'>{studentDetail?.PREFERRED_JOB_ROLE || '--'}</span></strong></div>
                                        </div>
                                        <div className='col-md-6 text-start'>
                                            <div>Preferred Job Location:<strong><span className='ps-2'>{studentDetail?.PREFERRED_JOB_LOCATION || '--'}</span></strong></div>
                                        </div>
                                        <div className='col-md-12'>
                                            <div>Domain Preference:<strong><span className='ps-2'>{studentDetail?.DOMAIN_PREFERENCE || '--'}</span></strong></div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='d-flex align-items-center'>
                                        <img src='/assets/images/icons/link.png' alt='Information' className='img-fluid me-2' />
                                        <p className='mb-0'>Portfolio & Social Links</p>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <div>Portfolio  :<strong><span className='ps-2'>{portfolio?.SELF || '--'}</span></strong></div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div>LinkedIn:<strong><span className='ps-2'>{portfolio?.LINKED_IN || '--'}</span></strong></div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div>GitHub:<strong><span className='ps-2'>{portfolio?.GITHUB || '--'}</span></strong></div>
                                        </div>

                                        <div className='col-md-6'>
                                            <div>WhatsApp:<strong><span className='ps-2'>{portfolio?.WHATSAPP || '--'}</span></strong></div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div>Facebook:<strong><span className='ps-2'>{portfolio?.FACEBOOK || '--'}</span></strong></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row my-4'>
                            <div className='col'>
                                <a className={`${styles['active-btn-tab']}`} href='#basic-detail'>Basic Details</a>
                            </div>
                            <div className='col'>
                                <a className={`${styles['btn-tab']}`} href='#education-detail'>Education Details</a>
                            </div>
                            <div className='col'>
                                <a className={`${styles['btn-tab']}`} href='#internship'>Internship & Work</a>
                            </div>
                            <div className='col'>
                                <a className={`${styles['btn-tab']}`} href='#skills'>Skills & Languages</a>
                            </div>
                            <div className='col'>
                                <a className={`${styles['btn-tab']}`} href='#project'>Projects</a>
                            </div>
                            <div className='col'>
                                <a className={`${styles['btn-tab']}`} href='#resume'>Resume</a>
                            </div>
                            <div className='col'>
                                <a className={`${styles['btn-tab']}`} href='#visume'>Visume</a>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12' id='basic-detail'>
                                <h3 className={`${styles['fs-13']} mb-0`}><img src='/assets/images/icons/user-square.png' alt='profile image' className='img-fluid me-2' />Basic Details</h3>
                            </div>
                            <div className='col-md-12 mt-3'>
                                <div className={`${styles['basic-card']}`}>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <p className='fs-14'><span className='fw-6'>Full Name:</span> {fullName}</p>
                                            <p className='fs-14'><span className='fw-6'>Date of Birth:</span> {studentDetail.DOB ? moment(studentDetail.DOB).format('DD MMM YYYY') : '--'}</p>
                                            <p className='fs-14'><span className='fw-6'>College:</span> {studentDetail.COLLEGE_NAME}</p>
                                            <p className='fs-14'><span className='fw-6'>Current Course:</span> {studentDetail?.QUALIFICATION_NAME ? (
                                                <>
                                                    {studentDetail.QUALIFICATION_NAME}
                                                    {studentDetail?.COURSE_NAME ? (
                                                        <React.Fragment>
                                                            &nbsp; in {studentDetail.COURSE_NAME}
                                                            {studentDetail?.SPECIALIZATION && (studentDetail.SPECIALIZATION)}
                                                        </React.Fragment>

                                                    ) : null}
                                                </>
                                            ) : '--'}</p>
                                        </div>
                                        <div className='col-md-6'>
                                            <p className='fs-14'><span className='fw-6'>Email:</span> {studentDetail.PERSONAL_EMAIL}</p>
                                            <p className='fs-14'><span className='fw-6'>Phone:</span> +91 {studentDetail.PHONE}</p>
                                            <p className='fs-14'><span className='fw-6'>Gender:</span> {studentDetail?.GENDER || "--"}</p>
                                            <p className='fs-14'><span className='fw-6'>Batch:</span> {studentDetail?.BATCH || "--"}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-12' id='education-detail'>
                                <h3 className={`${styles['fs-13']} my-3`}><img src='/assets/images/icons/graduation-hat.png' alt='profile image' className='img-fluid me-2' />Education</h3>
                            </div>
                            <div className="col-md-12" >

                                {educationList.reduce((rows, edu, index) => {
                                    if (index % 2 === 0) {
                                        rows.push(educationList.slice(index, index + 2));
                                    }
                                    return rows;
                                }, []).map((row, rowIndex) => (
                                    <div className={styles['basic-card']}>
                                        <div className="row" key={rowIndex}>
                                            {row.map((edu, idx) => (
                                                <div className="col-md-6" key={idx}>
                                                    <p className="fs-16 fw-6">{edu.QUALIFICATION_NAME}</p>
                                                    <p className="fs-14">Course: {edu.COURSE_STREAM}</p>
                                                    <p className="fs-14">Specialization: {edu.SPECIALIZATION}</p>
                                                    <p className="fs-14">
                                                        Marks: {edu.MARKS} ({edu.GRADING_SYSTEM_TYPE})
                                                    </p>
                                                    <p className="fs-14">Passout Year: {edu.PASSOUT_YEAR}</p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                ))}
                            </div>
                            <div className='col-md-12' id='internship'>
                                <h3 className={`${styles['fs-13']} my-3`}><img src='/assets/images/icons/backpack.png' alt='profile image' className='img-fluid me-2' />Internship & Work</h3>
                            </div>
                            <div className='col-md-12' >

                                {internshipList.length ? internshipList.map((int, i) => (
                                    <div className={styles['basic-card']} key={i}>

                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <p className='fs-16 fw-6'><b>{int.TITLE}</b> - {int.COMPANY_NAME}</p>
                                                <p className='fs-14'>Duration:<span className='fw-6 ms-1'>{int.FROM_DATE} to {int.PRESENT ? 'Present' : int.TO_DATE}</span></p>
                                                <p className='fs-14'>Responsibilities:<span className='fw-6 ms-1'>{int.DETAILS || '--'} </span></p>
                                                {/* <ul className='disc'>
                                                    <li className='fs-14'>Developed REST APIs using Node.js</li>
                                                    <li className='fs-14'>Assisted in frontend development using React</li>
                                                    <li className='fs-14'>Debugged and optimized modules</li>
                                                </ul> */}
                                            </div>
                                        </div>
                                    </div>
                                )) : <div className='col-md-12'>
                                    <div className={`${styles['basic-card']}`}>
                                        <div className='row'>
                                            <div className='col-md-12'>
                                                No Internship Found
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                                {/* <div className={`${styles['basic-card']}`}>
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <p className='fs-16 fw-6'>Software Development Intern – NexaSoft Pvt. Ltd.</p>
                                            <p className='fs-14'>Duration:<span className='fw-6 ms-1'>Jan 2024 – Apr 2024</span></p>
                                            <p className='fs-14'>Responsibilities:</p>
                                            <ul className='disc'>
                                                <li className='fs-14'>Developed REST APIs using Node.js</li>
                                                <li className='fs-14'>Assisted in frontend development using React</li>
                                                <li className='fs-14'>Debugged and optimized modules</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                            <div className='col-md-12' id='skills'>
                                <h3 className={`${styles['fs-13']} my-3`}><img src='/assets/images/icons/translate.png' alt='profile image' className='img-fluid me-2' />Skills & Languages</h3>
                            </div>
                            <div className='col-md-12' >
                                <div className={`${styles['basic-card']}`}>
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <div className={styles['basic-card']} >

                                                <div className='row'>
                                                    <div className='col-md-6'>
                                                        <p className='fs-16 fw-6'><b>Skills</b></p>
                                                        <ul className='disc'>

                                                            {skillList.map((item) => {
                                                                return (
                                                                    <li className='fs-14'>{item.SKILL} - {item.SKILL_PROFICIENT}</li>
                                                                )
                                                            })}
                                                        </ul>
                                                    </div>

                                                    <div className='col-md-6'>
                                                        <p className='fs-16 fw-6'><b>Languages</b></p>
                                                        <ul className='disc'>

                                                            {languageList.map((item) => {
                                                                return (
                                                                    <li className='fs-14'>{item.LANGUAGE} - {item.PROFICIENCY}</li>
                                                                )
                                                            })}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-12' id='project'>
                                <h3 className={`${styles['fs-13']} my-3`}><img src='/assets/images/icons/rocket.png' alt='profile image' className='img-fluid me-2' />Projects</h3>
                            </div>

                            <div className="col-md-12">

                                {
                                    projectList.length ? (
                                        projectList.reduce((rows, edu, index) => {
                                            if (index % 2 === 0) {
                                                rows.push(projectList.slice(index, index + 2));
                                            }
                                            return rows;
                                        }, []).map((row, rowIndex) => (
                                            <div className={styles['basic-card']}>
                                                <div className="row" key={rowIndex}>
                                                    {row.map((item, i) => (
                                                        <div className="col-md-6" key={i}>
                                                            <div className={styles['basic-card']}>

                                                                <p className="fs-16 fw-6">
                                                                    <b>{item.PROJECT_TITLE}</b>
                                                                </p>

                                                                <p className="fs-14">
                                                                    Team Size:
                                                                    <span className="fw-6 ms-1">{item.TEAM_SIZE}</span>
                                                                </p>

                                                                <p className="fs-14">
                                                                    Time Period:
                                                                    <span className="fw-6 ms-1">
                                                                        {item.WORKED_FROM_MONTH} - {item.WORKED_FROM_YEAR}
                                                                        {' '}to{' '}
                                                                        {item.PROJECT_STATUS === 'I'
                                                                            ? 'In Progress'
                                                                            : `${item.WORKED_TILL_MONTH} - ${item.WORKED_TILL_YEAR}`}
                                                                    </span>
                                                                </p>

                                                                <p className="fs-14">
                                                                    Project Detail:
                                                                    <span className="fw-6 ms-1">{item.PROJECT_DETAILS}</span>
                                                                </p>

                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                        ))
                                    ) : <div className="row">
                                        <div className="col-md-12">
                                            <div className={styles['basic-card']}>
                                                No Project Found
                                            </div>
                                        </div>
                                    </div>

                                }
                            </div>

                            <div className='col-md-12' id='resume'>
                                <h3 className={`${styles['fs-13']} my-3`}><img src='/assets/images/icons/file.png' alt='profile image' className='img-fluid me-2' />Resume</h3>
                            </div>
                            <div className='col-md-12'>
                                <div className={`${styles['basic-card']}`}>
                                    <div className="d-flex align-items-center justify-content-between">

                                        {/* LEFT: File */}
                                        <div className="d-flex align-items-center">
                                            <a
                                                href={`${process.env.REACT_APP_BASE_URL}/download/campus-resume/${RESUME_URL}`}
                                                target="_blank"
                                                rel="noreferrer"
                                                className={styles['resume-link']}
                                            >
                                                📄
                                                {`${fullName.replace(' ', '_')}_Resume.${RESUME_URL.split('.').pop()}`}
                                            </a>
                                        </div>

                                        {/* RIGHT: Uploaded Date */}

                                    </div>
                                </div>
                            </div>
                            {/* <div className='col-md-12' id='visume'>
                                <h3 className={`${styles['fs-13']} my-3`}><img src='/assets/images/icons/video-recorder.png' alt='profile image' className='img-fluid me-2' />Video Profile</h3>
                            </div>
                            <div className='col-md-12'>
                                <div className={`${styles['in-video-card']}`}>
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <div className={`${styles['video-card']}`}>
                                                <div className={`${styles['video-inner']}`}>
                                                    <span className={`${styles['video-text']}`}>Video</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            <div className='col-md-12' id='applied-job'>
                                <h3 className={`${styles['fs-13']} my-3`}><img src='/assets/images/icons/clipboard-check.png' alt='profile image' className='img-fluid me-2' />Applied Job</h3>
                            </div>
                            <div className='col-md-12'>
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <div className={`${styles['job-card']}`}>
                                            <div className='d-flex align-items-center justify-content-between'>
                                                <div>
                                                    <h3 className={`${styles['job-title']}`}>{jobDetail?.JOB_TITLE}</h3>
                                                    <p className={`${styles['job-tagline']} my-2`}>{jobDetail?.COMPANY_NAME}</p>
                                                </div>
                                                <div>
                                                    <span className={`${styles['app-job']}`}>{jobDetail?.APPLICATION_STATUS_NAME}</span>
                                                </div>
                                            </div>
                                            <div className='d-flex align-items-center'>
                                                <p className='mb-0'><img src='/assets/images/icons/suitecase.png' alt='suitecase' className='img-fluid me-2' />{jobDetail?.EMPLOYMENT_TYPE}</p>
                                                <p className='mb-0 mx-3'><img src='/assets/images/icons/marker-pin.png' alt='map' className='img-fluid me-2' />{jobDetail?.CITY}</p>
                                                <p className='mb-0'><img src='/assets/images/icons/calcheck.png' alt='calender check' className='img-fluid me-2' />{moment(jobDetail?.APPLIED_ON).format('DD MMM YYYY')}</p>
                                            </div>
                                            <div className='mt-3'>
                                                <select
                                                    className={`form-conrol ${styles['up-btn']}`}
                                                    // className="form-select"
                                                    onChange={(e) => {
                                                        const model = {
                                                            APPLICATION_ID: data.APPLICATION_ID,
                                                            STATUS_ID: e.target.value,
                                                            CANDIDATE_ID: data?.CANDIDATE_ID,
                                                            SOURCE: 'STUDENT',
                                                            CAMPUS_STUDENT_ID: STUDENT_ID,
                                                            JOB_ID: jobDetail.JOB_ID
                                                        }
                                                        UpdateJobResponse(model).then(res => {
                                                            if (res.status) {
                                                                toast.success(res.result.message)
                                                            }
                                                        }).catch(err => {
                                                            console.log(err)
                                                        })
                                                    }}
                                                >
                                                    <option value="">Update Status</option>
                                                    {statusList.map((i) => (
                                                        <option key={i.STATUS_ID} value={i.STATUS_ID}>
                                                            {i.STATUS_NAME}
                                                        </option>
                                                    ))}
                                                </select>
                                                {/* <button
                                                    type="button"
                                                    className={styles['up-btn']}
                                                    onClick={() => setShowStatusModal(true)}
                                                >
                                                    Update Status
                                                </button> */}

                                            </div>

                                        </div>
                                        {/* <div className={`${styles['job-card']} mt-3`}>
                                            <div className='d-flex align-items-center justify-content-between'>
                                                <div>
                                                    <h3 className={`${styles['job-title']}`}>Software Engineer – Trainee</h3>
                                                    <p className={`${styles['job-tagline']} my-2`}>NexaSoft Technologies Pvt. Ltd.</p>
                                                </div>
                                                <div>
                                                    <span className={`${styles['st-app-job']}`}>Shortlisted</span>
                                                </div>
                                            </div>
                                            <div className='d-flex align-items-center'>
                                                <p className='mb-0'><img src='/assets/images/icons/suitecase.png' alt='suitecase' className='img-fluid me-2' />Full-Time</p>
                                                <p className='mb-0 mx-3'><img src='/assets/images/icons/marker-pin.png' alt='map' className='img-fluid me-2' />Bangalore</p>
                                                <p className='mb-0'><img src='/assets/images/icons/calcheck.png' alt='calender check' className='img-fluid me-2' />22 Oct 2025</p>
                                            </div>
                                            <div className='mt-3'>
                                                <a href='#' className={`${styles['up-btn']}`}>Update Status</a>
                                            </div>
                                        </div>
                                        <div className={`${styles['job-card']} mt-3`}>
                                            <div className='d-flex align-items-center justify-content-between'>
                                                <div>
                                                    <h3 className={`${styles['job-title']}`}>Software Engineer – Trainee</h3>
                                                    <p className={`${styles['job-tagline']} my-2`}>NexaSoft Technologies Pvt. Ltd.</p>
                                                </div>
                                                <div>
                                                    <span className={`${styles['in-app-job']}`}>Interview Completed</span>
                                                </div>
                                            </div>
                                            <div className='d-flex align-items-center'>
                                                <p className='mb-0'><img src='/assets/images/icons/suitecase.png' alt='suitecase' className='img-fluid me-2' />Full-Time</p>
                                                <p className='mb-0 mx-3'><img src='/assets/images/icons/marker-pin.png' alt='map' className='img-fluid me-2' />Bangalore</p>
                                                <p className='mb-0'><img src='/assets/images/icons/calcheck.png' alt='calender check' className='img-fluid me-2' />22 Oct 2025</p>
                                            </div>
                                            <div className='mt-3'>
                                                <a href='#' className={`${styles['up-btn']}`}>Update Status</a>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CandidateDetail